import { SystemRole } from '../Enums/system-role.enum';
import { BillingTab } from '../Modules/Billing/Interfaces/billing-tab.interface';

export const ROLE_DOCUMENT_SEND = SystemRole.BACKOFFICE_AGENT;

export const ROLE_MONEY_OUT = SystemRole.BACKOFFICE_BILLING_ADMIN;

export const BILLING_TABS: readonly BillingTab[] = [
  { id: 'invoices', label: 'backoffice.billing.tabs.invoices', icon: 'description' },
  { id: 'payments', label: 'backoffice.billing.tabs.payments', icon: 'payments' },
  { id: 'refunds', label: 'backoffice.billing.tabs.refunds', icon: 'undo' },
  { id: 'credit-notes', label: 'backoffice.billing.tabs.credit_notes', icon: 'receipt' },
];

export const BILLING_DEFAULT_TAB = 'invoices';

export const BILLING_TAB_QUERY_PARAM = 'tab';

export const REASON_MAX = 500;

export const NOTE_MAX = 500;

export const INVOICE_RESEND_TITLE = 'backoffice.billing.invoice_actions.resend_title';

export const INVOICE_RESEND_CONSEQUENCE =
  'backoffice.billing.invoice_actions.resend_consequence';

export const INVOICE_RESENT_MESSAGE = 'backoffice.billing.invoice_actions.resent';

export const INVOICE_UNCOLLECTIBLE_TITLE =
  'backoffice.billing.invoice_actions.uncollectible_title';

export const INVOICE_UNCOLLECTIBLE_CONSEQUENCE =
  'backoffice.billing.invoice_actions.uncollectible_consequence';

export const INVOICE_UNCOLLECTIBLE_MESSAGE =
  'backoffice.billing.invoice_actions.uncollectible_done';

export const PAYMENT_RETRY_TITLE = 'backoffice.billing.payments.retry_title';

export const PAYMENT_RETRY_CONSEQUENCE = 'backoffice.billing.payments.retry_consequence';

export const PAYMENT_RETRIED_MESSAGE = 'backoffice.billing.payments.retried';

export const REFUND_CREATED_MESSAGE = 'backoffice.billing.refunds.created';

export const REFUND_ALREADY_RECORDED_MESSAGE = 'backoffice.billing.refunds.already_recorded';

export const CREDIT_NOTE_CREATED_MESSAGE = 'backoffice.billing.credit_notes.created';

export const CREDIT_NOTE_ALREADY_RECORDED_MESSAGE =
  'backoffice.billing.credit_notes.already_recorded';

export const CONFIRM_BUTTON = 'backoffice.common.actions.confirm';
